import { request } from '@/shared/api/request'

export const setSickLeave = ({ data }) => request({ url: `contract/sl/send`, method: 'POST', data })
